/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const onUserApproved = /* GraphQL */ `
  subscription OnUserApproved($id: String!) {
    onUserApproved(id: $id) {
      id
      identityId
      email
      alias
      firstName
      lastName
      dateOfBirth
      country
      state
      zip
      heardAboutUs
      watchedIntroVideo
      userStatus
      certificatePath
      disabledReason
      deletedReason
      scoreAwardLevels {
        key
        value
      }
      _deleted
      lastSignInAt
      approvedAt
      disabledAt
      deletedAt
      createdAt
      updatedAt
    }
  }
`;
export const onNotificationCreated = /* GraphQL */ `
  subscription OnNotificationCreated($recipient: String!) {
    onNotificationCreated(recipient: $recipient) {
      id
      title
      message
      type
      isRead
      recipient
      readAt
      createdAt
      updatedAt
    }
  }
`;
